import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      tableHeader: [
        { text: '', value: 'icon', align: 'center' },
        {
          text: 'تاریخ شروع',
          value: 'startDate',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'تاریخ اتمام',
          value: 'endDate',
          align: 'center',
          isGroupable: true,
        },
        { text: 'کد', value: 'code', align: 'center', isGroupable: true },
        {
          text: 'کاربر اول',
          value: 'firstUser',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'کاربر دوم',
          value: 'secondUser',
          align: 'center',
          isGroupable: true,
        },
        { text: 'توضیحات', value: 'note', align: 'center', isGroupable: true },
        {
          text: 'تعداد ماموریت',
          value: 'missionsCount',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'مدت کارکرد',
          value: 'workingDuration',
          align: 'center',
          isGroupable: true,
        },
        { text: 'عملیات', value: 'actions', align: 'center' },
      ],
      tableItems: [],
      searchFromDate: '',
      searchToDate: '',
      searchPhoneId: null,
      searchCityId: null,
      searchVehicleTypeId: null,
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
    };
  },
  methods: {
    makeDataReady: function (data) {
      this.tableItems = [];
      for (const item of data) {
        let startdate = '-';
        if (item.startDate) {
          startdate = Vue.moment(item.startDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        let endDate = '-';
        if (item.endDate) {
          endDate = Vue.moment(item.endDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        this.tableItems.push({
          startDate: startdate,
          endDate: endDate,
          code: item.phone && item.phone.code ? item.phone.code : '-',
          firstUser: item?.firstUser,
          secondUser: item.secondUser ? item.secondUser : '-',
          note: item.note ? item.note : '-',
          missionsCount: item.missionsCount.toString() ? item.missionsCount : '-',
          workingDuration: item?.durationInMinute
            ? this.convertMinutesToTime(item.durationInMinute)
            : '-',
          icon: 'mdi-ambulance mdi-18px',
          id: item.id,
        });
      }
    },
    setPreTimes: function () {
      this.tempSearchFromDate = '00:00:00 ';
      let temp = Vue.moment().format('jYYYY-jMM-jDD');
      this.tempSearchFromDate += temp;
      this.searchFromDate = Vue.moment().format('YYYY-MM-DD');
      this.searchFromDate += 'T00:00:00';
      this.searchToDate = Vue.moment().format('YYYY-MM-DDTHH:mm:ss');
      this.tempSearchToDate = Vue.moment().format('HH:mm:ss jYYYY-jMM-jDD');
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getAmarCodeReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchPhoneId,
        this.searchCityId,
        this.searchVehicleTypeId,
        this.page,
        this.pageSize,
      );
    },
    removeFilters: function () {
      this.searchPhoneId = null;
      this.searchCityId = null;
      this.searchVehicleTypeId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.setPreTimes();
      this.getAmarCodeReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchPhoneId,
        this.searchCityId,
        this.searchVehicleTypeId,
        this.page,
        this.pageSize,
      );
    },
    cancelSearch: function () {
      this.searchPhoneId = null;
      this.searchCityId = null;
      this.searchVehicleTypeId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.searchModal = false;
    },
    goToDetail: function (id) {
      this.$router.push({
        name: 'phoneActivityDetailReport',
        params: { id: id },
      });
    },
  },
};
